export default "__VITE_ASSET__A3zuxqlx__"